import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import AnchorLink from "../components/AnchorLinkComponent";
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class MobilePlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: ['xamarin','kotlin','react native','iOS','android'], andSearch: false, search: [], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Mobile Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body.TextPage.Section}>
                    <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have many years of experience in mobile development technologies. I started development with the predecessors to todays popular handheld devices.</p>
                    <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I added Android and iOS development in 2009.</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.text}>Here's what I can do in Mobile:</p>
                        <li><AnchorLink value="Android native development." style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/android'/></li>
                        <li><AnchorLink value="iOS native development." style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/ios'/></li>
                        <li><AnchorLink value="Xamarin hybrid development." style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/mobilehybrid'/>(Android and iOS cross platform)</li>
                        <li><AnchorLink value="React native hybrid development." style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/mobilehybrid'/>(Android and iOS cross platform)</li>
                        <li><AnchorLink value="Kotlin shared code hybrid development." style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/mobilehybrid'/></li>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Mobile projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default MobilePlatform



// WEBPACK FOOTER //
// src/Platforms/MobilePlatform.js